var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverRupeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.64 7.65566C72.5756 5.38346 77.4244 5.38346 81.36 7.65566L130.142 35.8199C134.077 38.0921 136.502 42.2913 136.502 46.8358V103.164C136.502 107.709 134.077 111.908 130.142 114.18L81.36 142.344C77.4244 144.617 72.5756 144.617 68.64 142.344L19.8581 114.18C15.9225 111.908 13.4981 107.709 13.4981 103.164V46.8358C13.4981 42.2913 15.9225 38.0921 19.8581 35.8199L68.64 7.65566Z",
    fill: "url(#paint0_linear_145_564)",
    stroke: "url(#paint1_linear_145_564)",
    strokeWidth: 6.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0805 98.2759L60.3447 77.8035V72.9788H64.2566C65.8214 72.9788 67.1906 72.7615 68.3641 72.3269C69.5812 71.8487 70.5809 71.175 71.3633 70.3057C72.1891 69.4364 72.7542 68.3932 73.0584 67.1762H60.3447V62.3515H72.9932C72.7324 61.2214 72.2761 60.2217 71.6241 59.3524C71.0155 58.483 70.1897 57.8093 69.1465 57.3312C68.1468 56.8096 66.9298 56.5488 65.4954 56.5488H60.3447V51.7241H89.7492V56.5488H79.5131C80.252 57.3747 80.8605 58.2657 81.3386 59.222C81.8602 60.1782 82.208 61.2214 82.3818 62.3515H89.7492V67.1762H82.5122C82.0776 70.3926 80.8388 72.9136 78.7959 74.7392C76.753 76.5213 74.1233 77.7383 70.9069 78.3903L83.6858 98.2759H72.0805Z",
    fill: "url(#paint2_linear_145_564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_564",
    x1: 75.0002,
    y1: -3.22716,
    x2: 75.0002,
    y2: 153.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_564",
    x1: 45.0581,
    y1: 57.9492,
    x2: 106.231,
    y2: 121.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_564",
    x1: 69.1775,
    y1: 69.7084,
    x2: 86.6534,
    y2: 81.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRupeIcon);
export default __webpack_public_path__ + "static/media/silver_rupeIcon.bd90b04762192ebb852602bec21272b2.svg";
export { ForwardRef as ReactComponent };